import { translate } from "app/filters/i18nFilter";
import NewAssetButtonTracked from "app/pages/sales-intelligence/pages/home/containers/NewAssetButton/NewAssetButtonTracked";
import TutorialViewTracked from "app/pages/sales-intelligence/pages/home/containers/TutorialView/TutorialViewTracked";
import { toggleOpportunityListModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { useDispatch } from "react-redux";
import { StyledButtonsContainer } from "../../components/styles";
import type { ViewModelMetadata } from "../../types/models";

type Props = {
    metadata: ViewModelMetadata;
};

const ListsEmptyCardActionsContainer = ({ metadata }: Props) => {
    const dispatch = useDispatch();

    const handleAddClick = () => {
        dispatch(toggleOpportunityListModal(true));
    };

    return (
        <StyledButtonsContainer>
            <NewAssetButtonTracked
                metadata={metadata}
                onClick={handleAddClick}
            >
                {translate("si.pages.home.card.lists.no-content.action.add")}
            </NewAssetButtonTracked>
            <TutorialViewTracked
                metadata={metadata}
                stateId="salesIntelligence-home-myLists"
            >
                {translate("si.pages.home.card.action.tutorial")}
            </TutorialViewTracked>
        </StyledButtonsContainer>
    );
};

export default ListsEmptyCardActionsContainer;
